export const useGetLocationByFitterIdStore = defineStore('getLocationByFitterId', () => {
  const inventoryAPI = useInventoryAPI();

  const getLocationByFitterId = ref<LocationDTO[]>([]);

  async function setLocationByFitterId() {
    const getLocationByFitterIdResponse: ResponseDTO<LocationDTO[]> | undefined = await inventoryAPI.getLocationByFitterId();

    if (getLocationByFitterIdResponse && !getLocationByFitterIdResponse.HasErrors) {
      getLocationByFitterId.value = getLocationByFitterIdResponse.Data;
    }
  }

  return {
    _getLocationByFitterId: getLocationByFitterId,
    getLocationByFitterId: readonly(getLocationByFitterId),
    setLocationByFitterId
  };
});
